import React, { useEffect } from 'react';
import { ErrorBoundary } from '@grc/ui-package';
import { I18nProvider } from './stores/settings/language-context';
import Layout from './pages/layout';
import AuthError from './auth0/auth-error';
import Loading from './auth0/loader';
import useAuthStartup from './auth0/useAuthStartup';
import { SettingsMenuProvider } from './contexts/settings/setting-menu-header-context';
import { useCustomerPortalGlobalStore } from './stores/customer-portal-global-store';
import { OrderProvider } from './stores/create-order/order-store';
import { BolOrderProvider } from './stores/create-order/order-store-bol';
import { QuoteProvider } from './stores/create-quote/quote-store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.light.css';
import './common/styles/global.scss';
import './app.scss';
import {
  applyCustomAccent,
  getCustomAccent
} from './common/themes/theme-color-utils';

export default function App() {
  // Logs the user in (with the loop guard) and holds the layout until the token has permissions.
  const { status, errorText, serviceMessage, layoutKey, retry, backToLogin } =
    useAuthStartup();
  const [selectedLanguage] = useCustomerPortalGlobalStore(
    store => store.store.selectedLanguage
  );
  const [selectedTheme] = useCustomerPortalGlobalStore(
    store => store.store.selectedTheme
  );
  //const { changeLanguage } = useDispatchActions();

  const renderContent = () => {
    if (status === 'accessDenied') {
      return (
        <AuthError
          errorText={errorText}
          serviceMessage={serviceMessage}
          onBackToLogin={backToLogin}
        />
      );
    }
    if (status === 'error' || status === 'redirectLoop') {
      return (
        <AuthError
          errorText={errorText}
          serviceMessage={serviceMessage}
          onRetry={retry}
        />
      );
    }
    return status === 'authenticated' ? <Layout key={layoutKey} /> : <Loading />;
  };

  useEffect(() => {
    const theme = selectedTheme === 'dark' ? 'dark' : 'light';
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('selectedTheme', theme);
    applyCustomAccent(getCustomAccent(), theme);
  }, [selectedTheme]);

  return (
    <div>
      <ErrorBoundary componentName="customer-portal">
        <I18nProvider languageKey={selectedLanguage}>
          <OrderProvider>
            <BolOrderProvider>
              <QuoteProvider>
                <SettingsMenuProvider>{renderContent()}</SettingsMenuProvider>
              </QuoteProvider>
            </BolOrderProvider>
          </OrderProvider>
        </I18nProvider>
      </ErrorBoundary>
    </div>
  );
}
